module.exports = __webpack_public_path__ + "img/zhaomu.b7dbcb3a.png";